/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TimeCategory } from './timeCategory';
import { StatusCodeValueTimeUseStandard } from './statusCodeValueTimeUseStandard';
import { StatusCodeValueNumberOfCips } from './statusCodeValueNumberOfCips';
import { AveragePowerConsumption } from './averagePowerConsumption';
import { StatusCodeValueNumberOfStartups } from './statusCodeValueNumberOfStartups';
import { StatusCodeValueMeanCurrent } from './statusCodeValueMeanCurrent';
import { StatusCodeValueOperatingHours } from './statusCodeValueOperatingHours';
import { StatusCodeValueBowlSpeed } from './statusCodeValueBowlSpeed';
import { StatusCodeValueNumberOfAlarms } from './statusCodeValueNumberOfAlarms';


export interface StandardAllInOneResponseDTO { 
    bowl_speed?: StatusCodeValueBowlSpeed;
    mean_current?: StatusCodeValueMeanCurrent;
    time_utilization?: TimeCategory;
    time_use?: StatusCodeValueTimeUseStandard;
    number_of_startups?: StatusCodeValueNumberOfStartups;
    number_of_alarms?: StatusCodeValueNumberOfAlarms;
    operating_hours?: StatusCodeValueOperatingHours;
    number_of_cips?: StatusCodeValueNumberOfCips;
    average_power_consumption?: Array<AveragePowerConsumption>;
}

